/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type NfcToken,
    NfcTokenFromJSON,
    NfcTokenToJSON,
} from '../models/NfcToken';
import {
    type NfcTokenCreate,
    NfcTokenCreateFromJSON,
    NfcTokenCreateToJSON,
} from '../models/NfcTokenCreate';
import {
    type NfcTokenSortKey,
    NfcTokenSortKeyFromJSON,
    NfcTokenSortKeyToJSON,
} from '../models/NfcTokenSortKey';
import {
    type NfcTokenUpdate,
    NfcTokenUpdateFromJSON,
    NfcTokenUpdateToJSON,
} from '../models/NfcTokenUpdate';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface NfcTokensCreateNfcTokenRequest {
    nfcTokenCreate: NfcTokenCreate;
}

export interface NfcTokensDeleteNfcTokenRequest {
    nfcTokenId: string;
}

export interface NfcTokensListNfcTokensRequest {
    pageSize: number;
    search?: string | null;
    userId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: NfcTokenSortKey;
}

export interface NfcTokensListNfcTokensMetadataRequest {
    pageSize: number;
    search?: string | null;
    userId?: string | null;
}

export interface NfcTokensReadNfcTokenRequest {
    nfcTokenId: string;
}

export interface NfcTokensUpdateNfcTokenRequest {
    nfcTokenId: string;
    nfcTokenUpdate: NfcTokenUpdate;
}

export interface NfcTokensValidateCreateNfcTokenRequest {
    nfcTokenCreate: NfcTokenCreate;
}

export interface NfcTokensValidateUpdateNfcTokenRequest {
    nfcTokenId: string;
    nfcTokenUpdate: NfcTokenUpdate;
}

/**
 * NfcTokensApi - interface
 * 
 * @export
 * @interface NfcTokensApiInterface
 */
export interface NfcTokensApiInterface {
    /**
     * Creates request options for nfcTokensCreateNfcToken without sending the request
     * @param {NfcTokenCreate} nfcTokenCreate 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensCreateNfcTokenRequestOpts(requestParameters: NfcTokensCreateNfcTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new NFC token.
     * @summary Create an NFC token
     * @param {NfcTokenCreate} nfcTokenCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensCreateNfcTokenRaw(requestParameters: NfcTokensCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NfcToken>>;

    /**
     * Create a new NFC token.
     * Create an NFC token
     */
    nfcTokensCreateNfcToken(requestParameters: NfcTokensCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NfcToken>;

    /**
     * Creates request options for nfcTokensDeleteNfcToken without sending the request
     * @param {string} nfcTokenId 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensDeleteNfcTokenRequestOpts(requestParameters: NfcTokensDeleteNfcTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the NFC token with the given ID.
     * @summary Delete an NFC token
     * @param {string} nfcTokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensDeleteNfcTokenRaw(requestParameters: NfcTokensDeleteNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the NFC token with the given ID.
     * Delete an NFC token
     */
    nfcTokensDeleteNfcToken(requestParameters: NfcTokensDeleteNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for nfcTokensListNfcTokens without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [userId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {NfcTokenSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensListNfcTokensRequestOpts(requestParameters: NfcTokensListNfcTokensRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the NFC tokens present. If `search` is specified, return values similar to the `description` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List NFC tokens
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [userId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {NfcTokenSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensListNfcTokensRaw(requestParameters: NfcTokensListNfcTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NfcToken>>>;

    /**
     * Lists all the NFC tokens present. If `search` is specified, return values similar to the `description` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List NFC tokens
     */
    nfcTokensListNfcTokens(requestParameters: NfcTokensListNfcTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NfcToken>>;

    /**
     * Creates request options for nfcTokensListNfcTokensMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [userId] 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensListNfcTokensMetadataRequestOpts(requestParameters: NfcTokensListNfcTokensMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Nfc token listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [userId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensListNfcTokensMetadataRaw(requestParameters: NfcTokensListNfcTokensMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Nfc token listing metadata
     */
    nfcTokensListNfcTokensMetadata(requestParameters: NfcTokensListNfcTokensMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for nfcTokensReadNfcToken without sending the request
     * @param {string} nfcTokenId 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensReadNfcTokenRequestOpts(requestParameters: NfcTokensReadNfcTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the NFC token specified by the given ID.
     * @summary Get a single NFC token
     * @param {string} nfcTokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensReadNfcTokenRaw(requestParameters: NfcTokensReadNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NfcToken>>;

    /**
     * Returns the NFC token specified by the given ID.
     * Get a single NFC token
     */
    nfcTokensReadNfcToken(requestParameters: NfcTokensReadNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NfcToken>;

    /**
     * Creates request options for nfcTokensUpdateNfcToken without sending the request
     * @param {string} nfcTokenId 
     * @param {NfcTokenUpdate} nfcTokenUpdate 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensUpdateNfcTokenRequestOpts(requestParameters: NfcTokensUpdateNfcTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the NFC token specified by the given ID.
     * @summary Update NFC token
     * @param {string} nfcTokenId 
     * @param {NfcTokenUpdate} nfcTokenUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensUpdateNfcTokenRaw(requestParameters: NfcTokensUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NfcToken>>;

    /**
     * Update the NFC token specified by the given ID.
     * Update NFC token
     */
    nfcTokensUpdateNfcToken(requestParameters: NfcTokensUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NfcToken>;

    /**
     * Creates request options for nfcTokensValidateCreateNfcToken without sending the request
     * @param {NfcTokenCreate} nfcTokenCreate 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensValidateCreateNfcTokenRequestOpts(requestParameters: NfcTokensValidateCreateNfcTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new NFC token without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate an NFC token
     * @param {NfcTokenCreate} nfcTokenCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensValidateCreateNfcTokenRaw(requestParameters: NfcTokensValidateCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new NFC token without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an NFC token
     */
    nfcTokensValidateCreateNfcToken(requestParameters: NfcTokensValidateCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for nfcTokensValidateUpdateNfcToken without sending the request
     * @param {string} nfcTokenId 
     * @param {NfcTokenUpdate} nfcTokenUpdate 
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensValidateUpdateNfcTokenRequestOpts(requestParameters: NfcTokensValidateUpdateNfcTokenRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given NFC token, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate NFC token update
     * @param {string} nfcTokenId 
     * @param {NfcTokenUpdate} nfcTokenUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NfcTokensApiInterface
     */
    nfcTokensValidateUpdateNfcTokenRaw(requestParameters: NfcTokensValidateUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given NFC token, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate NFC token update
     */
    nfcTokensValidateUpdateNfcToken(requestParameters: NfcTokensValidateUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class NfcTokensApi extends runtime.BaseAPI implements NfcTokensApiInterface {

    /**
     * Creates request options for nfcTokensCreateNfcToken without sending the request
     */
    async nfcTokensCreateNfcTokenRequestOpts(requestParameters: NfcTokensCreateNfcTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nfcTokenCreate'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenCreate',
                'Required parameter "nfcTokenCreate" was null or undefined when calling nfcTokensCreateNfcToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NfcTokenCreateToJSON(requestParameters['nfcTokenCreate']),
        };
    }

    /**
     * Create a new NFC token.
     * Create an NFC token
     */
    async nfcTokensCreateNfcTokenRaw(requestParameters: NfcTokensCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NfcToken>> {
        const requestOptions = await this.nfcTokensCreateNfcTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NfcTokenFromJSON(jsonValue));
    }

    /**
     * Create a new NFC token.
     * Create an NFC token
     */
    async nfcTokensCreateNfcToken(requestParameters: NfcTokensCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NfcToken> {
        const response = await this.nfcTokensCreateNfcTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for nfcTokensDeleteNfcToken without sending the request
     */
    async nfcTokensDeleteNfcTokenRequestOpts(requestParameters: NfcTokensDeleteNfcTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nfcTokenId'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenId',
                'Required parameter "nfcTokenId" was null or undefined when calling nfcTokensDeleteNfcToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/{nfc_token_id}`;
        urlPath = urlPath.replace('{nfc_token_id}', encodeURIComponent(String(requestParameters['nfcTokenId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the NFC token with the given ID.
     * Delete an NFC token
     */
    async nfcTokensDeleteNfcTokenRaw(requestParameters: NfcTokensDeleteNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.nfcTokensDeleteNfcTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the NFC token with the given ID.
     * Delete an NFC token
     */
    async nfcTokensDeleteNfcToken(requestParameters: NfcTokensDeleteNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nfcTokensDeleteNfcTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for nfcTokensListNfcTokens without sending the request
     */
    async nfcTokensListNfcTokensRequestOpts(requestParameters: NfcTokensListNfcTokensRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling nfcTokensListNfcTokens().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the NFC tokens present. If `search` is specified, return values similar to the `description` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List NFC tokens
     */
    async nfcTokensListNfcTokensRaw(requestParameters: NfcTokensListNfcTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NfcToken>>> {
        const requestOptions = await this.nfcTokensListNfcTokensRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NfcTokenFromJSON));
    }

    /**
     * Lists all the NFC tokens present. If `search` is specified, return values similar to the `description` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List NFC tokens
     */
    async nfcTokensListNfcTokens(requestParameters: NfcTokensListNfcTokensRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NfcToken>> {
        const response = await this.nfcTokensListNfcTokensRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for nfcTokensListNfcTokensMetadata without sending the request
     */
    async nfcTokensListNfcTokensMetadataRequestOpts(requestParameters: NfcTokensListNfcTokensMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling nfcTokensListNfcTokensMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Nfc token listing metadata
     */
    async nfcTokensListNfcTokensMetadataRaw(requestParameters: NfcTokensListNfcTokensMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.nfcTokensListNfcTokensMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Nfc token listing metadata
     */
    async nfcTokensListNfcTokensMetadata(requestParameters: NfcTokensListNfcTokensMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.nfcTokensListNfcTokensMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for nfcTokensReadNfcToken without sending the request
     */
    async nfcTokensReadNfcTokenRequestOpts(requestParameters: NfcTokensReadNfcTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nfcTokenId'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenId',
                'Required parameter "nfcTokenId" was null or undefined when calling nfcTokensReadNfcToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/{nfc_token_id}`;
        urlPath = urlPath.replace('{nfc_token_id}', encodeURIComponent(String(requestParameters['nfcTokenId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the NFC token specified by the given ID.
     * Get a single NFC token
     */
    async nfcTokensReadNfcTokenRaw(requestParameters: NfcTokensReadNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NfcToken>> {
        const requestOptions = await this.nfcTokensReadNfcTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NfcTokenFromJSON(jsonValue));
    }

    /**
     * Returns the NFC token specified by the given ID.
     * Get a single NFC token
     */
    async nfcTokensReadNfcToken(requestParameters: NfcTokensReadNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NfcToken> {
        const response = await this.nfcTokensReadNfcTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for nfcTokensUpdateNfcToken without sending the request
     */
    async nfcTokensUpdateNfcTokenRequestOpts(requestParameters: NfcTokensUpdateNfcTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nfcTokenId'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenId',
                'Required parameter "nfcTokenId" was null or undefined when calling nfcTokensUpdateNfcToken().'
            );
        }

        if (requestParameters['nfcTokenUpdate'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenUpdate',
                'Required parameter "nfcTokenUpdate" was null or undefined when calling nfcTokensUpdateNfcToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/{nfc_token_id}`;
        urlPath = urlPath.replace('{nfc_token_id}', encodeURIComponent(String(requestParameters['nfcTokenId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: NfcTokenUpdateToJSON(requestParameters['nfcTokenUpdate']),
        };
    }

    /**
     * Update the NFC token specified by the given ID.
     * Update NFC token
     */
    async nfcTokensUpdateNfcTokenRaw(requestParameters: NfcTokensUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NfcToken>> {
        const requestOptions = await this.nfcTokensUpdateNfcTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NfcTokenFromJSON(jsonValue));
    }

    /**
     * Update the NFC token specified by the given ID.
     * Update NFC token
     */
    async nfcTokensUpdateNfcToken(requestParameters: NfcTokensUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NfcToken> {
        const response = await this.nfcTokensUpdateNfcTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for nfcTokensValidateCreateNfcToken without sending the request
     */
    async nfcTokensValidateCreateNfcTokenRequestOpts(requestParameters: NfcTokensValidateCreateNfcTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nfcTokenCreate'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenCreate',
                'Required parameter "nfcTokenCreate" was null or undefined when calling nfcTokensValidateCreateNfcToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NfcTokenCreateToJSON(requestParameters['nfcTokenCreate']),
        };
    }

    /**
     * Validate data for a new NFC token without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an NFC token
     */
    async nfcTokensValidateCreateNfcTokenRaw(requestParameters: NfcTokensValidateCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.nfcTokensValidateCreateNfcTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new NFC token without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an NFC token
     */
    async nfcTokensValidateCreateNfcToken(requestParameters: NfcTokensValidateCreateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nfcTokensValidateCreateNfcTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for nfcTokensValidateUpdateNfcToken without sending the request
     */
    async nfcTokensValidateUpdateNfcTokenRequestOpts(requestParameters: NfcTokensValidateUpdateNfcTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['nfcTokenId'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenId',
                'Required parameter "nfcTokenId" was null or undefined when calling nfcTokensValidateUpdateNfcToken().'
            );
        }

        if (requestParameters['nfcTokenUpdate'] == null) {
            throw new runtime.RequiredError(
                'nfcTokenUpdate',
                'Required parameter "nfcTokenUpdate" was null or undefined when calling nfcTokensValidateUpdateNfcToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nfc_tokens/{nfc_token_id}/validate`;
        urlPath = urlPath.replace('{nfc_token_id}', encodeURIComponent(String(requestParameters['nfcTokenId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: NfcTokenUpdateToJSON(requestParameters['nfcTokenUpdate']),
        };
    }

    /**
     * Validate data for updating the given NFC token, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate NFC token update
     */
    async nfcTokensValidateUpdateNfcTokenRaw(requestParameters: NfcTokensValidateUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.nfcTokensValidateUpdateNfcTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given NFC token, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate NFC token update
     */
    async nfcTokensValidateUpdateNfcToken(requestParameters: NfcTokensValidateUpdateNfcTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nfcTokensValidateUpdateNfcTokenRaw(requestParameters, initOverrides);
    }

}
